<template>
  <v-list-item-icon class="mr-3" style="margin-top: 13px">
    <module-icon-with-badge
      :badgeYOffset="12"
      :module="module"
      :iconColor="iconColor"
      :unreadCountBadgeColor="unreadCountBadgeColor"
      :unreadCount="unreadCount"
      :invertImgIcons="invertImgIcons"
      :isUnreadCountFeatureEnabled="isUnreadCountFeatureEnabled"
    ></module-icon-with-badge>
  </v-list-item-icon>
</template>

<script>
import ModuleIconWithBadge from '@/components/icons/ModuleIconWithBadge';

export default {
  name: 'NavDrawerListItemIcon',
  components: {
    ModuleIconWithBadge,
  },
  mounted() {
    console.debug('invertImgIcons', this.invertImgIcons);
  },
  props: {
    invertImgIcons: { type: Boolean, default: false },
    unreadCount: { type: Number },
    isUnreadCountFeatureEnabled: { type: Boolean, default: true },
    module: {
      type: Object,
    },
    iconColor: {
      type: String,
    },
    unreadCountBadgeColor: {
      type: String,
    },
  },
};
</script>
